module.exports = __webpack_public_path__ + "img/laureatte.7825c4cb.png";